module.exports = __webpack_public_path__ + "static/media/Print.186d1bdd.svg";